import { doc, setDoc } from "firebase/firestore"
import { useState } from "react"
import { FiChevronRight } from "react-icons/fi"
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md"
import { db } from "../config/firebase"

export function StockItem() {

    return (
        <>
            <div>
                <div className="stock-card-item">
                    <div>
                        <p style={{ fontSize: 12, color: '#808080', marginBottom: 10 }}>Service Name</p>
                        <input placeholder="Service Name" />
                    </div>
                    <div>
                        <p style={{ fontSize: 12, color: '#808080', marginBottom: 10 }}>Service Description</p>
                        <input placeholder="Service Description" />
                    </div>
                    <div>
                        <p style={{ fontSize: 12, color: '#808080', marginBottom: 10 }}>Service Price</p>
                        <input placeholder="Service Price" />
                    </div>
                    <div className="check-box">
                        <input type="checkbox" />
                        <p>Available In Stock</p>
                    </div>
                </div>
                <button>Update Service</button>
            </div>
        </>
    )
}

export default function StockList({ services, width, setLoading }) {

    const [currect, setCurrect] = useState(0)

    async function toggleShow(group, item, items) {
        setLoading(true)
        await setDoc(doc(db, `services/` + group), {
            services: items.map(l => l.id === item ? ({
                ...l,
                show: !l.show
            }) : l)
        }, { merge: true })
        setLoading(false)
    }

    return (
        <div id="pos-wrapper">
            {width > 768 && <div id="services-list">
                    {services?.map((service , i) => (
                        <div className="services-list-item" key={service.id}
                            style={{ 
                                borderBottomWidth: i === services.length - 1 ? 0 : 3,
                                backgroundColor: i === currect ? "var(--warnColor)" : 'transparent'
                            }}
                            onClick={() => setCurrect(i)}
                        >
                            <p style={{ paddingLeft: 10 }}>{service.title}</p>
                            <FiChevronRight size={20} />
                        </div>
                    ))}
                </div>}
                <div id="services-items-wrapper">
                    {((width <= 768) ? services : [services[currect]])?.map(service => (
                            <div className="services-wrapper" key={service?.id}>
                                {(width <= 768 ) && (
                                    <div className="service-header">
                                        <h2>{service.title}</h2>
                                    </div>
                                )}
                                <div className="services-items-wrapper">
                                    {service?.services?.map(item => (
                                        <div className="services-item-wrapper" 
                                            style={{
                                                borderLeft: "3px solid var(--warnColor)",
                                                borderLeftColor: item.show ? "var(--successColor)" : "var(--errorColor)"
                                            }}
                                            key={item?.id} onClick={() =>toggleShow(service.id, item.id, service?.services)}>
                                            <div className="services-item-details" >
                                                <p>{item.title} <span style={{ color: item.show ? "var(--successColor)" : "var(--errorColor)"}}>({(item.show ? "Available" : "Not Available")})</span></p>
                                                <p>R{Number(item.price).toFixed(2)}</p>
                                            </div>
                                            <div className="services-item-quantity" >
                                                {item.show ? <MdCheckBox size={27} color={item.show ? "var(--successColor)" : "var(--errorColor)"} /> : <MdCheckBoxOutlineBlank size={27} color={item.show ? "var(--successColor)" : "var(--errorColor)"} />}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                    }
                </div>
        </div>
    )
}